<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=600 content-class="round-2xl" persistent)
  v-card
    v-card-title.pa-0
    div.px-6.pt-2
      .text-lg.font-medium.mt-6 {{ $t('unsaved_document_title') }}
      .text-md.mt-4 {{ $t('unsaved_document_description') }}
    v-divider.mt-6
    v-card-actions.px-6.py-3
      v-btn.button-md.neutral700--text.underline(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md.mr-1(:loading="isLoading" color="danger500" outlined @click="onQuitAndDiscard") {{ $t('quit_and_discard') }}
      v-btn.button-md(:loading="isLoading" color="neutral700" depressed dark @click="onSaveAndQuit") {{ $t('save_and_quit') }}
</template>

<script>

export default {
  props: {
    open: {
      type: Boolean,
    },
  },
  data: () => ({
    isLoading: false
  }),
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    onQuitAndDiscard () {
      this.$emit('quitAndDiscard')
      this.showDialog = false
    },
    onSaveAndQuit () {
      this.$emit('saveAndQuit')
      this.showDialog = false
    }
  }
}
</script>